import * as React from "react"
import PageLanding from "./subtemplates/subtemplate_landing"

const PageLandingTemplate = props => <PageLanding {...props} />
export default PageLandingTemplate